<template>
  <!--下载页面-->
  <div>
    <van-col span="24" :style="{'background': 'url('+ bg_img +')'}" class="download_bg_img" @click="download_Jump">
    </van-col>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  export default {
    data() {
      return {
        bg_img: '',
        url: '',
        avatar: '',
      };
    },
    created: function() {
      this.getRoom()
      document.title = this.$t('title.visitor')
    },
    methods: {
      // 设置默认值
      getRoom(){

        // 前端拦截处理是否下载过app,已有app打开app,否则进入应用市场安装
        // room_id房间id roomType 几人直播间 classification 1公开2私密3会员
        let id = this.$route.params.id
        if (id === undefined) {
          const pathname = this.location.pathname
          const pathall =  pathname.split('/')
          if (pathall.length > 0) {
            id = pathall[pathall.length - 1]
          }
        }
        console.log(id)
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/room_index_api/select_room",{
          params:{
            id : id,
          }
        }).then(res => {
          if(res.data.code == 1 && res.data.data){
            const roomType = res.data.data.room_type
            const classification = res.data.data.type
            this.avatar = res.data.data.avatar
            window.location.href="bogoxq://is_open_app?room_id=" + id + "&roomType="+ roomType +"&classification=" + classification;
          }
          this.initialization()
        })
      },
      // 设置默认值
      initialization(){
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/download_api/duwnload_app").then(res => {
          this.bg_img = res.data.data.bg_img
          this.url = res.data.data.url
          this.avatar = this.avatar ? this.avatar : res.data.data.system_log
          this.headIcon()
        })
      },
      headIcon(){
        console.log(this.avatar)
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = this.avatar;
        document.getElementsByTagName('head')[0].appendChild(link);
      },
      download_Jump(){
        window.location.href= this.url;
      }
    }
  }
</script>
<style>
  .download_bg_img{min-height: 100vh;background-size:100% auto!important;  background-repeat: no-repeat!important;display:inline-block;}
</style>



// WEBPACK FOOTER //
// src/components/download.vue